import controller from './kform-builder-option-label-position.controller';
import template from './kform-builder-option-label-position.html';

const kformBuilderOptionLabelPositionDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionLabelPositionDirective;
